import { AssetResponseModel } from '../models/assetsModel';

export const AssetResponseEntity = ({ data, included }: AssetResponseModel): Readonly<AssetResponseModel> => {
  return Object.freeze({ data, included });
};
